export interface FormConsentState {
  privacyConsent: boolean;
  marketingConsent?: boolean;
  /** When true, the marketing checkbox must also be checked before submit. */
  requireMarketing?: boolean;
}

/** Returns true when every visible consent checkbox on the form is checked. */
export function areFormConsentsComplete({
  privacyConsent,
  marketingConsent = false,
  requireMarketing = false,
}: FormConsentState): boolean {
  if (!privacyConsent) return false;
  if (requireMarketing && !marketingConsent) return false;
  return true;
}

/** Returns true when every additional CMS/custom checkbox value is checked. */
export function areAllCheckboxesChecked(values: boolean[]): boolean {
  if (values.length === 0) return true;
  return values.every(Boolean);
}
